<ng-template cellTemplate let-dataItem="dataItem">
    <div (click)="$event['ignoreClickOutside'] = true" class="cell-template"
         [ngClass]="cellClassGetter ? cellClassGetter(undefined, dataItem) : {}">
        {{dataItem | property:field | wbo_time:pattern}}
    </div>
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-columnIndex="columnIndex"
             let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <fui-time-control #editControl [formControl]="formGroup.get(column.field)" [control]="formGroup.get(column.field)"
                      [ngClass]="cellClassGetter ? cellClassGetter(formGroup, dataItem) : {}" [attr.id]="elementId"
                      [readOnly]="cellDisabled(formGroup, dataItem)" (focussed$)="columnFocusHandler(columnIndex)"
                      (valueChange)="valueChanged($event, dataItem, formGroup)"></fui-time-control>
</ng-template>
